<div class="layout">
  <aside class="sidebar">
    <app-sidebar />
  </aside>
  <main class="content">
    <router-outlet />
  </main>
</div>
